import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEjendomstjekRouteTracking } from "~/routes/(restricted)/ejendomstjek/address/-hooks/useEjendomstjekRouteTracking";

export const Route = createFileRoute("/(restricted)/ejendomstjek/address")({
  component: RouteComponent,
});

function RouteComponent() {
  // Setup Ejendomstjek tracking
  useEjendomstjekRouteTracking();

  return (
    <div className="w-full px-4 md:px-8 xl:px-20">
      <Outlet />
    </div>
  );
}
